import { createStyles, makeStyles } from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useAuth } from "../../hooks/auth";
import { Supplier } from "../../interfaces/Supplier";
import SupplierApi from "../../services/SupplierApi";

type ComboProps = any;

const SelectParameter: React.FC<ComboProps> = ({marginGird, name, multiple, defaultValue, control, style, serviceType, label, onChange, disabled, setValue, loadUserSupplier, indCDLC, onSelect, showDefailedOptions=false, allowCodeSearch=false, ...restProps}) => {
  const { user } = useAuth();
  const { t: _t } = useTranslation("General");
  const [ defaultOptions, setDefaultOptions ] = useState<any>((user.isSupplier ? user.suppliers : []) ?? []);

  const useStyles = makeStyles(() =>
    createStyles({
        root: {
          margin: marginGird ? marginGird : '10px',
          "& .MuiAutocomplete-tag":{
            margin: "6px",
          },
          "& .MuiChip-root":{
            margin: '3px',
            marginTop: "0px",
            marginBottom: "0px",
            height: '29px',
          },          
        },
        lightText: {
          color: "#999"
        }
    })
  );

  const classes = useStyles();

  const timeoutRef = useRef<any>(null);

  if (user.isSupplier && serviceType != "T")
  {
    loadUserSupplier = (loadUserSupplier === undefined) ? true : loadUserSupplier;

    //Se User Fornecedor tiver um unico fornecedor selecionavel, desabilitar o campo para que ja fique selecionado
    if (loadUserSupplier && defaultOptions.length === 1 && setValue !== undefined)
    {
      disabled = true;
      let selectedSupplier = (multiple ? defaultOptions : defaultOptions[0]);
      setValue(name, selectedSupplier);
      if (onChange) onChange(selectedSupplier);
    }
  }

  const handleSearchSupplier = async(val: any) => {
    let items: any[] = [];
    let systemID = 10;

    if (user.isSupplier && serviceType !== "T")
      items = defaultOptions;
    else
    
      await SupplierApi.search(val, user.company.plantID, serviceType, systemID, indCDLC)
      .then(result => {
        items = result.items.map((supplier: Supplier) => {
          return { 
              label: `${supplier.supplierID} - ${supplier.name.trim()} ${serviceType === `T` ? ` - ` + supplier.cnpj + (supplier.locality && supplier.locality.trim() ? ` (` + supplier.locality.trim() + `/` + supplier.region + `)` : ``) : supplier.systemSuppliers[0]?.isJIT ? ` - JIT` : ` - Não JIT`} `,
              code: supplier.supplierID,
              name: supplier?.name?.trim(),
            };
          })
        });
      setDefaultOptions(items);
  }

  const onChange_ = async (value: []) =>{
    let newList:any[] = [];
    value.forEach((x: any) => {
        if (!newList.find((y: any) => y.code == x.code))
            newList.push(x);

    });
    setValue(name, newList);
  }

  const filterOptions = createFilterOptions({ stringify: (option:any) => ( `${option.code} ${option.label}`) });


  return (
    <Controller
      name={name}
      control={control}
      render={({ field: props, fieldState: { error } }) => (
        <Autocomplete
            multiple={multiple}
            id={name}
            options={defaultOptions}
            getOptionLabel={(option) => option.label}
            onChange={(_, data) => {

              props.onChange(data); 
              if (onChange)              
                onChange(data)
              
              if (setValue)
                onChange_(data)
            }}
            value={props.value}
            loadingText={"Buscando..."}
            onSelect={onSelect}
            getOptionSelected={(option: any, value: any) => {
              return option.label !== undefined ? option === value : false;
            }}
            defaultValue={defaultValue}
            renderOption={showDefailedOptions ? (item) => (<div>{item.label}<br/><small className={classes.lightText}>{item.code}</small></div>) : undefined}
            filterOptions={allowCodeSearch ? filterOptions : undefined}
            limitTags={100}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label={label}
                onChange={(e: any) => handleSearchSupplier(e.target.value)}
                placeholder="..."
              />
            )}
          />
    )} />
  )
}

export default SelectParameter;
